import axios from 'axios'
const API_URL = '/texts/'


// Add text
const addText = async (data, token) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
};
  const response = await axios.post(API_URL, data, config)

  return response.data
}

// Add text
const updateText = async (data, token) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  };
  const url = API_URL + data.id;
  const response = await axios.put(url, data, config)
  return response.data
}

// Get texts
const getTexts = async () => {
  // extract language frokm cache
  const language = localStorage.getItem('lang') || 'lv';
  const url = API_URL + '?lang' + '=' + language;

  const response = await axios.get(url)
  return response.data
}

// Get texts admin
const getTextsAdmin = async (token) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  };

  const url = API_URL + 'admin';
  const response = await axios.get(url, config)
  return response.data
}

const textService = {
  getTexts,
  addText,
  updateText,
  getTextsAdmin
}

export default textService